<script lang="ts" setup>
defineSlots<{
  default: () => VNode[];
}>();

// Links inside articles always open in a new tab (external and internal alike).
const additionalAttrs = computed(() => ({ rel: 'noreferrer noopener', target: '_blank' }));
</script>

<template>
  <NuxtLink class="contentProseA" v-bind="additionalAttrs">
    <slot />
  </NuxtLink>
</template>

<style lang="scss">
.contentProseA {
  color: #8ab845;
  transition: color 0.3s ease;

  &:hover {
    color: #121212;
  }
}
</style>
